import {
  DEFAULT_FORM_INPUT_LABEL_CLASS_NAME,
  LARGE_INPUT_LABEL_CLASS_NAME,
  ONBOARDING_INPUT_LABEL_CLASS_NAME,
} from '../../constants/input-label';

const formInputLabel = ({ theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  color: theme.palette.text.primary,
  '&.Mui-focused': {
    color: theme.palette.text.highlight,
  },
  '&.MuiInputLabel-shrink': {
    transform: 'translate(14px, -9px)',
    backgroundColor: 'white',
    padding: '0 4px',
    borderRadius: 8,
  },
  '&.Mui-selected': {
    color: theme.palette.text.highlight,
  },
  '&.Mui-error': {
    color: theme.palette.error.A600,
    '& .MuiInputLabel-asterisk': {
      color: theme.palette.error.A600,
    },
  },
});

const onboardingInputLabel = () => ({
  fontSize: 14,
  fontWeight: 600,
});

const MuiInputLabel = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.gray.A700,
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '140%',
      padding: '0 4px 0 4px',
      '&.Mui-focused': {
        color: theme.palette.primary.A500,
        '& .MuiInputLabel-asterisk': {
          color: theme.palette.primary.A500,
        },
      },
      '&.Mui-error': {
        color: theme.palette.error.A600,
        '& .MuiInputLabel-asterisk': {
          color: theme.palette.error.A600,
        },
      },
      '&.Mui-disabled': {
        color: theme.palette.gray.A400,
        backgroundColor: 'white',
        '& .MuiInputLabel-asterisk': {
          color: theme.palette.gray.A400,
        },
      },
      [`&.${DEFAULT_FORM_INPUT_LABEL_CLASS_NAME}`]: formInputLabel({ theme }),
      [`&.${ONBOARDING_INPUT_LABEL_CLASS_NAME}`]: { ...formInputLabel({ theme }), ...onboardingInputLabel({ theme }) },
      [`&.${LARGE_INPUT_LABEL_CLASS_NAME}`]: {
        fontSize: 14,
        '&.MuiInputLabel-shrink': {
          transform: 'translate(14px, -9px)',
          backgroundColor: 'white',
          padding: '0 4px',
          borderRadius: 8,
        },
      },
    }),
    asterisk: ({ theme }) => ({
      color: theme.palette.error.A600,
      fontSize: 14,
    }),
  },
};

export default MuiInputLabel;
